import React from 'react';

const GameHeader = ({ tapCount, speed }) => {
  return (
    <div className="game-header">
      <h1>🚗 RACE TO THE CLIENT! 🏁</h1>
      <div className="stats">
        <div className="stat-item">
          <span className="stat-label">Taps:</span>
          <span className="stat-value">{tapCount}</span>
        </div>
                                               <div className="stat-item">
                  <span className="stat-label">Speed:</span>
                  <span className="stat-value">{speed.toFixed(2)}</span>
                  <span className="unit">TPS</span>
                </div>
      </div>
    </div>
  );
};

export default GameHeader;
